import { deserialise, serialise } from 'kitsu-core'
import { getRequest, postRequest, patchRequest, deleteRequest } from '@/plugins/api-axios'
import store from '@/store'
import { getURL, authorizationBaseUrl, getRequestHeaders } from '@/utils/axios'
import { initDialog } from '@/utils/dialog'
import CompanyAdminPostDialog from '@/views/Authorization/dialogs/companyAdminPost.vue'
import CompanyAdminProjectsAccess from '@/views/Authorization/dialogs/companyAdminProjectsAccess.vue'
import CompanyAdminDeleteDialog from '@/views/Authorization/dialogs/companyAdminDelete.vue'
import UserOffboardDialog from '@/views/Authorization/dialogs/userOffboard.vue'

export async function searchProjectUsers(filters: Record<string, any>) {
    let { data } = await getRequest(
        getURL({
            path: `projectUsers`,
            base: authorizationBaseUrl,
            params: {
                ...filters,
                include: 'user.employer,project',
            },
        }),
        getRequestHeaders('GET')
    )

    return deserialise(data).data
}

export async function initOffboarding(user: {
    user?: Record<string, any>
    email?: string
    projectUsers: Array<Record<string, any>>
}) {
    return await initDialog(UserOffboardDialog, { user })
}

export async function patchProjectUser(data, include = 'user,company,roles') {
    let payload = serialise('projectUser', data)

    let res = await patchRequest(
        getURL({
            path: `projectUsers/${data.id}`,
            base: authorizationBaseUrl,
            params: {
                include,
            },
        }),
        getRequestHeaders('PATCH'),

        payload.data
    )

    return deserialise(res.data).data
}

export async function offboard(projectUser) {
    let data = {
        id: projectUser.id,
        type: projectUser.type,
        roles: { data: [] },
    }

    return await patchProjectUser(data)
}

export async function searchCompanyAdminsByUser(userId: string, save = false) {
    let { data } = await getRequest(
        getURL({
            path: `companyAdmins`,
            base: authorizationBaseUrl,
            params: {
                'filter[user]': userId,
                'page[limit]': 10000,
                include: 'company',
            },
        }),
        getRequestHeaders('GET')
    )

    let res = deserialise(data).data

    if (save) {
        store.commit('companyAdmins', res)
    }
    return res
}

export async function searchCompanyAdminsByCompany(companyId: string) {
    let { data } = await getRequest(
        getURL({
            path: `companyAdmins`,
            base: authorizationBaseUrl,
            params: {
                'filter[company]': companyId,
                'page[limit]': 10000,
                include: 'user.employer',
            },
        }),
        getRequestHeaders('GET')
    )

    let res = deserialise(data).data

    return res
}

export async function initPostAdmin(user: Record<string, any>, company: Record<string, any>) {
    return await initDialog(CompanyAdminPostDialog, { user, company })
}

export async function confirmAccessToAllCompanyProjects(
    user: Record<string, any>,
    company: Record<string, any>
) {
    return await initDialog(CompanyAdminProjectsAccess, { user, company })
}

export async function patchAdmin(id: string, data: Record<string, any>) {
    let payload = serialise('companyAdmin', { id, ...data })

    let res = await patchRequest(
        getURL({
            path: `companyAdmins/${id}`,
            base: authorizationBaseUrl,
        }),
        getRequestHeaders('PATCH'),
        payload.data
    )

    return deserialise(res.data).data
}

export async function postAdmin(data: Record<string, any>) {
    let payload = serialise('companyAdmin', data)

    let res = await postRequest(
        getURL({
            path: `companyAdmins`,
            base: authorizationBaseUrl,
            params: {
                include: 'user.employer',
            },
        }),
        getRequestHeaders('POST'),

        payload.data
    )

    return deserialise(res.data).data
}

export async function initDeleteAdmin(user: Record<string, any>, company: string) {
    return await initDialog(CompanyAdminDeleteDialog, { user, company })
}

export async function deleteAdmin(companyAdminId: string) {
    return await deleteRequest(
        getURL({
            path: `companyAdmins/${companyAdminId}`,
            base: authorizationBaseUrl,
        }),
        getRequestHeaders('DELETE')
    )
}
